<template>
  <BaseForm :loading="loading" :errorMessage="error" class="noprogress" :excluded-countries="excludedCountries">
      <template v-slot:header>
        {{$t('qic_quote_header')}}
      </template>
      <template v-slot:logo>
        <slot name="logo"></slot>
      </template>
      <div class="quote">
        <slot></slot>
      </div>
  </BaseForm>
</template>

<script>
import BaseForm from '../BaseForm'
export default {
  name: 'BaseQuote',
  props: [
    'loading',
    'error',
    'excludedCountries'
  ],
  components: {
    BaseForm
  }
}
</script>
